// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyGitSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="m22.104 12.978-9.126 9.126a1.353 1.353 0 0 1-1.913 0l-9.169-9.169a1.353 1.353 0 0 1 0-1.913l6.287-6.286 2.38 2.38a1.61 1.61 0 0 0 .874 2.111v5.766a1.61 1.61 0 1 0 1.323.047V9.327l2.172 2.171a1.61 1.61 0 1 0 .963-.907l-2.328-2.328a1.607 1.607 0 0 0-2.033-2.048L9.119 3.8l1.903-1.904a1.352 1.352 0 0 1 1.913 0l9.169 9.169a1.353 1.353 0 0 1 0 1.913z"
    />
  </svg>
);
export default SvgTechnologyGitSolid;
